export const profile = {
  name: "奥田咲",
  romanized: "Saki Okuda",
  birthday: "1994 年 3 月 17 日",
  birthplace: "日本 · 神奈川县",
  height: "162 cm",
  bloodType: "O 型",
  measurements: "B84 / W58 / H86",
  agency: "青叶演艺事务所",
  debut: "2018 年 · 短片《夏日残响》",
  languages: "日语 / 基础英语",
  hobbies: ["摄影", "钢琴", "海边散步", "旧电影收藏"],
  photo:
    "https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20a%20young%20japanese%20woman%20in%20a%20minimal%20deep%20blue%20gray%20knit%20sweater%2C%20soft%20studio%20lighting%20with%20warm%20orange%20accent%20light%20from%20one%20side%2C%20clean%20neutral%20background%2C%20calm%20confident%20expression%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=okuda-profile-main&orientation=portrait",
  bio: [
    "奥田咲，1994 年出生于日本神奈川县。2018 年凭借短片《夏日残响》正式进入影视行业，随后以电影《遥远的约定》完成大银幕首秀。",
    "她的表演风格以克制、细腻著称，善于在几乎没有台词的场景中传递复杂情绪。2021 年的电影《静海之忆》被视为她表演道路上的重要转折点，也让她第一次进入主流奖项的视野。",
    "此后她陆续出演了《星降之夜》《等待春天的车站》《光与影之间》等剧集，题材横跨都市、悬疑与治愈，逐步形成了「安静但有力量」的个人标签。",
    "除了表演，她近年也开始参与剧本讨论与幕后工作，并持续参与关注儿童阅读的公益企划。",
  ],
  socials: [
    { name: "X（Twitter）", icon: "ri-twitter-x-line", url: "https://rajamas.asia/okuda-saki-x", handle: "@okuda_saki" },
    { name: "Instagram", icon: "ri-instagram-line", url: "https://rajamas.asia/okuda-saki-ig", handle: "@saki.okuda" },
    { name: "YouTube", icon: "ri-youtube-line", url: "https://rajamas.asia/okuda-saki-yt", handle: "奥田咲 Official" },
    { name: "官方微博", icon: "ri-weibo-line", url: "https://rajamas.asia/okuda-saki-weibo", handle: "@奥田咲" },
  ],
  representativeWorkIds: ["w09", "w03", "w14", "w05", "w10", "w13"],
  careerStats: [
    { label: "出道年份", value: "2018" },
    { label: "影视作品", value: "20+" },
    { label: "主竞赛入围", value: "4 次" },
    { label: "最佳女主角提名", value: "2 次" },
  ],
};